export default {
  UNLOCKED: {
    value: 0,
    label: 'Unlocked'
  },
  LOCKED: {
    value: 1,
    label: 'Locked'
  },
  LOCKED_INCOMING: {
    value: 2,
    label: 'Locked Incoming'
  },
  LOCKED_OUTGOING: {
    value: 3,
    label: 'Locked Outgoing'
  }
};
